import Dexie from "dexie";

export const db = new Dexie("OfflineFieldDB");

db.version(1).stores({
  pending_tasks: "++id, profil_no, status", // Mevcut tablo
  sondaj_verileri: "++id, sonda_no, job_id, status", // YENİ TABLO
});

// KALICI DEPOLAMA: Tarayici depolama baskisi altinda (ozellikle telefonlarda,
// bir sure kullanilmayan sitelerde) IndexedDB'yi KENDILIGINDEN silebilir; ajanin
// henuz senkronize etmedigi taslaklar boylece kaybolur. persist() istegi,
// verinin kullanici izni olmadan silinmesini engeller. Desteklenmiyorsa veya
// reddedilirse sessizce gecilir.
if (
  typeof navigator !== "undefined" &&
  navigator.storage &&
  typeof navigator.storage.persist === "function"
) {
  navigator.storage
    .persisted()
    .then((zatenKalici) => (zatenKalici ? true : navigator.storage.persist()))
    .catch(() => {});
}
